import styled from 'styled-components';

import {
  ImageLightbox,
  ImageLightboxWrapper,
} from './activity-builder-image-lightbox.style';
import { grey5 } from 'approot/shared/styles/colours.style';

export const DrawLightbox = styled(ImageLightbox)`
  height: 80vh;
`;

export const DrawLightboxImage = styled(ImageLightboxWrapper)`
  border: 1px solid ${grey5};
`;
